<script setup>

import { defineProps } from 'vue';

defineProps({
  message: {
    type: String,
    default: undefined
  }
});
</script>

<template>
  <div v-show="message">
    <p class="text-xs text-red-600 dark:text-red-400">
      {{ message }}
    </p>
  </div>
</template>
